import { TableContainer, TableRow, TableHead } from "@mui/material";
import styled from "styled-components";

export const StyledTableContainer = styled(TableContainer)({
  border: "1px solid #E7E5E4",
  borderRadius: "8px",
  backgroundColor: "white",
  "& .MuiTableCell-root": {
    borderBottom: "1px solid #E7E5E4",
    fontSize: 14,
  },
});

export const StyledTableRow = styled(TableRow)({
  cursor: "pointer",
  "&:hover": {
    backgroundColor: "#F7F6F5",
  },
});

export const StyledTableHead = styled(TableHead)({
  "& th": {
    fontSize: 18,
    minWidth: 120,
  },
});
